module.exports = __webpack_public_path__ + "img/close.5d23ee2.png";